<app-dynamic-modal *ngFor="let modal of modals$ | async" [modal]="modal" class="dynamic-modal" @modalAnimation></app-dynamic-modal>
